import React from 'react';

const LoadingSpinner = ({ message = "Loading...", size = "medium" }) => {
  // Size classes
  const sizeClass = {
    small: "font-size-18",
    medium: "font-size-24",
    large: "font-size-32"
  }[size] || "font-size-24";

  return (
    <div className="text-center text-muted py-4">
      <i className={`ri-loader-4-line spin ${sizeClass} d-block mb-2`}></i>
      {message}
    </div>
  );
};

export default LoadingSpinner; 